import { useQuery } from '@tanstack/react-query';

import configurationService from './configurationService';

import { ConfigurationQueryKey } from '@/constants/QueryKeys';

export const useGetConfiguration = (options?: { enabled?: boolean }) => {
    return useQuery({
        queryKey: [ConfigurationQueryKey.CONFIGURATION],
        queryFn: configurationService.getConfiguration,
        enabled: options?.enabled,
    });
};
